import { useMemo } from 'react';

import LandingPageFAQsSection from 'my-components/LandingPage/LandingPageFAQsSection';

function answerComponent(text) {
  return function Answer() {
    return <p>{text}</p>;
  };
}

export default function MedSchoolFaqSection({ color = 'primary', faqs }) {
  const faqGroups = useMemo(
    () => [{ faqs: faqs.map(({ a, q }) => ({ answer: answerComponent(a), question: q })) }],
    [faqs],
  );

  return <LandingPageFAQsSection color={color} faqGroups={faqGroups} />;
}
